import { render, staticRenderFns } from "./PageUnauthorized.vue?vue&type=template&id=eaa0ab22"
import script from "./PageUnauthorized.vue?vue&type=script&lang=js"
export * from "./PageUnauthorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports